<script>
	export let html;
</script>

<div class="custombutton-container marginbox">
	{@html html.fixImageAndApiLinkPath()}
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.custombutton-container {
		margin-bottom: $spacing-mobile-half;
	}
	
	.custombutton-container {
		width: 100%;
	}
	
	.custombutton-container button {
		margin: 0 0 $spacing-mobile 0;
		padding: 0;
		background-color: transparent;
		border: none;
		
		&.w_100 {
			width: 100%;
			
			@include for-big-desktop-up {
				width: 30%;
			}
		}
		
		&.w_auto {
			width: auto;
		}
		
		&.left {
			float: left;
		}
		
		&.right {
			float: right;
		}
		
		&.center {
			display: block;
			margin-left: auto;
			margin-right: auto;
		}

		&.margin-top {
			margin-top: $media-gap;
		}
		
		a {
			width: 100%;
			display: block;
			padding: .75em 0;
			text-align: center;
			text-transform: uppercase;
			border-radius: var(--border-burgeins);
			text-decoration: none;
			background-color: var(--color-burgeins-6);
			color: #ffffff;

			&.blue {
				padding: .5em 2em;
			}
			
			&.margin-top {
				margin-top: $media-gap;
			}
		}
	}
	
	.see_more_button {
		position: relative;
		color: $color-burgeins-6;
		text-transform: uppercase;
		white-space: nowrap;
	}
</style>
